import { render, staticRenderFns } from "./slideShowDetail.vue?vue&type=template&id=66df06b7&scoped=true&"
import script from "./slideShowDetail.vue?vue&type=script&lang=js&"
export * from "./slideShowDetail.vue?vue&type=script&lang=js&"
import style0 from "./slideShowDetail.vue?vue&type=style&index=0&id=66df06b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66df06b7",
  null
  
)

export default component.exports